export default __webpack_public_path__ + "static/media/kr.7c6ab0d2.svg";